export const leftCenter = "2 / -1";
export const center = "2 / 3";
export const fullscreen = "1 / -1";
